import type { ConsentPreferences } from './consent';

/** GA4 purchases have one owner: the durable paid-order server pipeline. */
export function browserMaySendGa4Event(eventName: string) {
  return eventName !== 'purchase';
}

export function isRealPaidPurchase(order: { paymentStatus: string; paymentMethod?: string | null }) {
  return order.paymentStatus === 'PAID' && order.paymentMethod !== 'test';
}

/** Stable browser deduplication key for a server-generated order number. */
export function purchaseTrackingKey(orderNumber: string) {
  return `printen_purchase_tracked_${String(orderNumber || '').trim()}`;
}

/**
 * The browser fallback must remain retryable while optional consent is denied.
 * The server-side paid-order pipeline remains the source of truth in that
 * case; this only controls whether the client may mark its fallback as sent.
 */
export function browserPurchaseMayBeMarkedTracked(consent: ConsentPreferences) {
  return consent.analytics === true || consent.marketing === true;
}
